import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';

import { DualMultiselect } from 'spicecomponents';

import { updateClusterList } from '../../../containers/App/actions';

class MultiselectContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      countryGroup: props.arrayItems,
    };
  }
  onChange(val) {
    if (typeof this.props.onChange === 'function') {
      this.props.onChange(this.props.index, val);
    }
  }
  onAnswerChange(val) {
    const value = val.map(({ value }) => value);
    this.setState({
      countryGroup: value,
    });

    this.onChange(value);
    this.props.updateCountryList(this.props.index, value);
  }
  getAnswerOptions() {
    const countries = this.props.controlList.Options[this.getSurvey()];
    const cdfValues = this.props.storedList || [];
    const selectedInOtherGroups = [].concat(...cdfValues.filter((v, i) => i !== this.props.index));

    // Return list of all countries that are not selected in another group
    return countries.filter((c) => selectedInOtherGroups.indexOf(c) === -1).map((v) => ({ value: v }));
  }
  getAnswerValue() {
    return this.state.countryGroup || [];
  }
  getSurvey() {
    const survey = this.props.cdf.Survey;
    if (!survey || survey.length > 1) {
      return 'AllSurveys';
    }
    return survey[0];
  }
  render() {
    return (
      <div>
        <DualMultiselect options={this.getAnswerOptions()} value={this.getAnswerValue()} onChange={(e) => this.onAnswerChange(e)} />
      </div>
    );
  }
}

MultiselectContainer.propTypes = {
  arrayItems: PropTypes.array,
  index: PropTypes.number,
  controlList: PropTypes.object,
  cdf: PropTypes.object,
  onChange: PropTypes.func,
  updateCountryList: PropTypes.func.isRequired,
  storedList: PropTypes.array.isRequired,
};

const mapStateToProps = createStructuredSelector({});

export function mapDispatchToProps(dispatch) {
  return {
    updateCountryList: (index, value) => {
      dispatch(updateClusterList(index, value, 'CountryList'));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(
  withConnect,
)(MultiselectContainer);



// WEBPACK FOOTER //
// ./app/components/FormControls/CountryList/MultiselectContainer.js